import React, { FC, useCallback, useState } from "react";
import { IDocument, IProjectFailureMode, IRiskAssessment } from "../types/types";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, TextField,
    Typography
} from "@material-ui/core";


import DialogContentText from "@material-ui/core/DialogContentText";
import Documents from "./documents";

interface IRiskAssessmentProps {
    risk_assessment: IRiskAssessment
    updateRiskAssessmentCallback: (risk_assessment: IRiskAssessment) => void;
    closeDialogCallback: () => void;

}

const AddRiskAssessmentDialog: FC<IRiskAssessmentProps> = ({
    risk_assessment,
    closeDialogCallback,
    updateRiskAssessmentCallback }) => {

    const [newRiskAssessment, setNewRiskAssessment] = useState<IRiskAssessment>(risk_assessment);



    let initial_selection_id = ""
    if (risk_assessment.project_failure_mode) {
        if (risk_assessment.project_failure_mode.id) {
            initial_selection_id = risk_assessment.project_failure_mode.id.toString()
        }
    }
    const [documentRef, setDocumentRef] = useState<IDocument>(() => {
        if (risk_assessment.document) {
            return risk_assessment.document
        }
        return {}
    }

    );


    const updateDocumentSelection = useCallback((documentRef: IDocument) => {
        setDocumentRef(documentRef)

    }, [setDocumentRef]);

    const renderField = <T,>(obj: T, key: keyof T, label: string, type: string) => {
        return <div>
            <div style={{
                width: "100%",
                margin: "auto",
            }}>
                <TextField
                    fullWidth
                    label={label}
                    value={obj[key]}
                    onChange={(event) => {
                        let v = (event.target.value as string);

                        let c = { ...obj };
                        if (type == "string") {
                            (c as any)[key] = v
                        }
                        if (type == "number") {
                            // Allow valid number strings, including those in scientific notation (e.g., '1e-5')
                            if (v === '' || /^-?\d*\.?\d*e?-?\d*$/i.test(v)) {
                                (c as any)[key] = v === '' ? '' : v; // Store the string to preserve 'e' notation until valid
                            }
                        }
                        setNewRiskAssessment(c)

                    }
                    }
                    type={type}

                    // onBlur is used to finally parse the string to a float when the user leaves the field
                    onBlur={() => {
                        if (type === "number") {
                            let c = { ...obj };
                            let numValue = parseFloat((c as any)[key]);
                            if (!isNaN(numValue)) {
                                (c as any)[key] = numValue;
                                setNewRiskAssessment(c);
                            }
                        }
                    }}
                />
            </div>
        </div>
    }

    const submitAssessment = () => {
        let ra = { ...newRiskAssessment }
        if (documentRef?.id) {
            ra["document_id"] = documentRef.uuid;
        }
        updateRiskAssessmentCallback(ra)
        closeDialogCallback()
    }

    return (<Dialog open={true} onClose={closeDialogCallback} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Upload Risk Assessments</DialogTitle>

        <DialogContent>
            <DialogContentText>
                <Typography>
                    Add new risk assessment
                </Typography>
                <p>
                    {renderField<IRiskAssessment>(newRiskAssessment, "failure_mode", "Failure Mode", "string")}
                    {renderField<IRiskAssessment>(newRiskAssessment, "description", "Description", "string")}
                    {renderField<IRiskAssessment>(newRiskAssessment, "annual_failure_probability", "annual failure probability", "number")}
                    {renderField<IRiskAssessment>(newRiskAssessment, "societal_risk", "societal risk", "number")}
                    {renderField<IRiskAssessment>(newRiskAssessment, "individual_risk", "individual risk", "number")}
                </p>

                <Documents updateDocumentID={updateDocumentSelection} documentID={documentRef ? documentRef.id : undefined} />
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={closeDialogCallback} color="primary">
                Cancel
            </Button>
            <Button onClick={submitAssessment} color="primary">
                Submit
            </Button>
        </DialogActions>
    </Dialog>
    )
}

export default AddRiskAssessmentDialog;
